const conf = process.env.NODE_ENV === 'production' ? {
    requestUrl: window.__CONFIG__.requestUrl,
    socketRequestPath: window.__CONFIG__.socketRequestPath,
    api: window.__CONFIG__.api,
    helpApi: window.__CONFIG__.helpApi,
    locale: window.__CONFIG__.locale,
    basename: window.__CONFIG__.basename,
    identityPath: window.__CONFIG__.identityPath,
    edePath: window.__CONFIG__.edePath,
    clientId: window.__CONFIG__.clientId,
    LPSapiUrl: window.__CONFIG__.LPSapiUrl,
    LPSsocketUrl: window.__CONFIG__.LPSsocketUrl,
    chatWidgetUrl: window.__CONFIG__.chatWidgetUrl,
    chatWidgetId: window.__CONFIG__.chatWidgetId
} : {
    // Prod ----
    // api: 'https://www.compuaccess.ee/caApi/',
    // requestUrl: 'https://www.compuaccess.ee/',
    // socketRequestPath: 'https://www.compucash5.com/',
    // helpApi: 'https://www.compuaccess.ee/helpdocumentation/',
    // locale: 'et',
    // basename: '',
    // identityPath: 'https://www.compucash5.com/identityserver/',
    // edePath: 'https://www.compuaccess.ee/sleepwellMTS/',
    // clientId: 'caWeb_2'
    // Dev ----
    requestUrl: 'https://cc5api.ektaco.ee/',
    socketRequestPath: 'https://cc5api.ektaco.ee/',
    // Lokaalseks arenduseks: `npm run dev:local` (või CA_API_URL .env-is) suunab API
    // lokaalse WorkTimeService peale; muidu jääb dev-serveri API.
    api: process.env.CA_API_URL || 'https://cc5api.ektaco.ee/wtsApi-dev/',
    helpApi: 'https://cc5api.ektaco.ee/helpdocumentation/',
    locale: 'et',
    basename: '',
    identityPath: 'https://cc5api.ektaco.ee/identityServer/',
    edePath: 'https://cc5api.ektaco.ee/sleepwellMTS/',
    clientId: 'caWeb_2',
    // Direct to the LPS API, as in the deployed builds, so the Passages pages act with the operator's own rights. The
    // LPS API answers CORS for cc5api.ektaco.ee only, so locally it is reached through the dev server (see
    // webpack.config.dev.js). The WTS proxy is no stand-in: its CompuAccessApi key has no master key or write rights.
    LPSapiUrl: `${window.location.origin}/mu4Api-dev`,
    LPSsocketUrl: 'wss://cc5api.ektaco.ee/mu4Api-dev/WsApiReports',
    // Bilbo chatbot: port 5173 on Bilbo vite dev-serveri proxy → BilboAPI :3300;
    // töötab ka otse http://localhost:3300/api/widget/widget.js, kui vite't ei jooksuta.
    chatWidgetUrl: 'http://localhost:5173/api/widget/widget.js',
    chatWidgetId: 'wgt_Vwx2cRQcqFLL5KVCsafNo4AE'
};
export default conf;
